import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { Container } from './styles';

const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export default function FeesPreviewTable({
  start,
  term,
  vehicle,
  uber,
  monthly,
  activation,
}) {
  const endDate = useMemo(() => {
    if (!term || !start) {
      return 'SIMULATION';
    }
    const date = new Date(start);
    date.setMonth(start.getMonth() + Number(term));
    return format(date, 'MM/dd/yyyy');
  }, [start, term]);
  return (
    <Container>
      <tbody>
        <tr>
          <td>
            <strong>Subscription Start Date: </strong>
            {start ? format(start, 'MM/dd/yyyy') : 'SIMULATION'}
          </td>
          <td>
            <strong>Term: </strong>
            {term} months
          </td>
          <td>
            <strong>Turn in Date: </strong>
            {endDate}
          </td>
        </tr>
        <tr>
          <td>
            <strong>Vehicle: </strong>
            {vehicle.displayName}
          </td>
          <td>
            <strong>VIN: </strong>
            {vehicle.vin}
          </td>
          <td>
            <strong>Mileage: </strong>
            {vehicle.mileage} miles
          </td>
        </tr>
        <tr>
          <td>
            <strong>Monthly Rate: </strong>
            {formatter.format(Number(monthly))}
          </td>
          <td>
            <strong>Sales Tax: </strong>
            {formatter.format(Number(monthly) * 0.07)}
          </td>
          <td>
            <strong>Total Payment: </strong>
            {formatter.format(Number(monthly) + Number(monthly) * 0.07)}
          </td>
        </tr>
        <tr>
          <td>
            <strong>Activation Payment: </strong>
            {formatter.format(Number(activation))}
          </td>
          <td>
            <strong>Sales Tax: </strong>
            {formatter.format(Number(activation) * 0.07)}
          </td>
          <td>
            <strong>Total Payment: </strong>
            {formatter.format(Number(activation) + Number(activation) * 0.07)}
          </td>
        </tr>
        <tr>
          <td>
            <strong>Florida Surcharge (incl. tax): </strong>64.20
          </td>
          <td>
            <strong>Total Due At Signing: </strong>
            {formatter.format(
              Number(monthly) +
                Number(monthly) * 0.07 +
                (Number(activation) + Number(activation) * 0.07) +
                64.2
            )}
          </td>
          <td />
        </tr>
        <tr>
          <td>
            <strong>Allowable monthly miles: </strong>
            {uber ? 'UNLIMITED' : '1,000'}
          </td>
          <td>
            <strong>Mileage overage penalty: </strong>
            {uber ? '$0.00' : '$0.25'}
          </td>
          <td />
        </tr>
      </tbody>
    </Container>
  );
}

FeesPreviewTable.defaultProps = {
  start: undefined,
  monthly: undefined,
  activation: undefined,
};
FeesPreviewTable.propTypes = {
  term: PropTypes.string.isRequired,
  start: PropTypes.instanceOf(Date),
  vehicle: PropTypes.shape({
    displayName: PropTypes.string,
    vin: PropTypes.string,
    mileage: PropTypes.number,
    monthly: PropTypes.shape({
      six: PropTypes.number,
      twelve: PropTypes.number,
      twentyFour: PropTypes.number,
    }),
    activation: PropTypes.shape({
      six: PropTypes.number,
      twelve: PropTypes.number,
      twentyFour: PropTypes.number,
    }),
  }).isRequired,
  monthly: PropTypes.number,
  activation: PropTypes.number,
};
